import { useSelector } from 'react-redux';
import { Navigate } from 'react-router';

import { LoadingScreen } from '@components/LoadingScreen';
import { useMe } from '@hooks/useMe';
import { useUserPermissions } from '@hooks/useUserPermissions';
import { Roles } from '@rdTypes/shared';

import { setErrorMFA } from '@redux/slices/auth';
import { RootState, useDispatch } from '@redux/store';

type RoleBasedGuardProp = {
  accessibleRoles: Roles[];
  children: React.ReactElement;
};

export const RoleBasedGuard = ({ accessibleRoles, children }: RoleBasedGuardProp) => {
  const { currentUser } = useMe();
  const dispatch = useDispatch();
  const isErrorMFA = useSelector((state: RootState) => state.auth.isErrorMFA);

  if (isErrorMFA && currentUser?.twoFactorEnabled) {
    dispatch(setErrorMFA(false));
  }

  const { isAllowed } = useUserPermissions();

  if (!currentUser) return <LoadingScreen />;

  if (!isAllowed(accessibleRoles)) {
    return <Navigate to="404" />;
  }

  return children;
};
